import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Home from './pages/Home';
import Services from './pages/Services';
import Projects from './pages/Projects';
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';
import Footer from './components/Footer';
import './App.css';
import Expertise from './pages/Expertise';
import Publications from './pages/Publications';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />

      <Routes>
        <Route path='/' element={<Home />}> </Route>
        <Route path='/expertise' element={<Expertise />}> </Route>
        <Route path='/services' element={<Services />}> </Route>
        <Route path='/projects' element={<Projects />}> </Route>
        <Route path='/about-us' element={<AboutUs />}> </Route>
        <Route path='/publications' element={<Publications />}> </Route>
        <Route path='/contact' element={<Contact />}> </Route>
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;